import Modal from '../../../components/Modal';
import { formFieldClass, formShell } from '../../../styles/formShell';
import { aiChatShell } from '../../../styles/aiChatShell';

/**
 * チャットモーダルコンポーネント
 */
export default function ChatModals({
    isConfirmOpen,
    closeConfirm,
    handleNewConversation,
    purging,
    isSendConfirmOpen,
    closeSendConfirm,
    sendMessage,
    pendingInput,
    loading,
    isEditOpen,
    closeEdit,
    handleConfirmEdit,
    editContent,
    setEditContent,
    editingMessage,
    showTurn = false,
}) {
    return (
        <>
            <Modal
                isOpen={isConfirmOpen}
                onClose={closeConfirm}
                title="新しいチャットを開始しますか？"
                size="small"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    { label: "開始する", variant: "primary", onClick: handleNewConversation, disabled: purging, closeOnClick: false }
                ]}
            >
                <p>現在の会話履歴はクリアされ、新しい会話が開始されます。</p>
            </Modal>
            <Modal
                isOpen={isSendConfirmOpen}
                onClose={closeSendConfirm}
                title="メッセージを送信しますか？"
                size="large"
                align="left"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    { label: "送信する", variant: "primary", onClick: sendMessage, disabled: loading || purging }
                ]}
            >
                <div>
                    <div className={aiChatShell.modalMessagePreview}>
                        <div className={aiChatShell.modalMessagePreviewContent}>
                            {pendingInput}
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isEditOpen}
                onClose={closeEdit}
                title="メッセージを編集"
                size="large"
                align="left"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    {
                        label: "再送信",
                        variant: "primary",
                        onClick: handleConfirmEdit,
                        disabled: loading || purging || !editContent.trim()
                    }
                ]}
            >
                <div>
                    <label className={`${formShell.label} ${aiChatShell.modalEditLabel}`}>
                        {showTurn && editingMessage?.turn !== undefined
                            ? `ターン ${editingMessage.turn}`
                            : 'メッセージ内容'}
                    </label>
                    <textarea
                        value={editContent}
                        onChange={(e) => setEditContent(e.target.value)}
                        className={`${formFieldClass(false, 'textarea')} min-h-[7.5rem]`}
                        placeholder="メッセージを編集してください"
                    />
                    <div className={aiChatShell.modalEditNotice}>
                        <strong>注意：</strong>このメッセージより後の会話は消えます。編集したメッセージから会話が再開されます。
                    </div>
                </div>
            </Modal>
        </>
    );
}
